import { Li, PBoldExt, PExt } from 'components/myTags/myTags'
import PdfReader from 'components/pdfReader/pdfReader'
import HTMLReactParser from 'html-react-parser'
import { useState } from 'react'
import Popup from 'reactjs-popup'
import { Colors } from 'styles/colors'

export default function InfosRh() {
   const [initialPage, setInitialPage] = useState(1)
   const [isPopupOpen, setIsPopupOpen] = useState(false)

   function openPdf(page: number) {
      setInitialPage(page)
      setIsPopupOpen(true)
   }

   const closePopup = () => setIsPopupOpen(false)

   const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
      const target = event.target as HTMLElement

      if (target.tagName === 'U' && target.textContent) {
         const pageNumber = parseInt(target.textContent, 10)
         if (!isNaN(pageNumber)) {
            openPdf(pageNumber)
         }
      }
   }

   const colorLi = Colors.gris1
   const Li3 = [
      '• La mutuelle : frais de santé<br>et prévoyance (page <u>21</u>)',
      '• Votre santé (page <u>22</u>)',
      '• Votre salaire (pages <u>23</u> à <u>25</u>)',
      '• Participation / Intéressement (page <u>26</u>)',
      '• Compte Épargne Temps – CET (page <u>27</u>)',
      '• Les congés (pages <u>28</u> à <u>31</u>)',
      '• L’assistante sociale (page <u>32</u>)',
      '• L’action logement (page <u>33</u>)',
   ]
   const Li4 = [
      '• Les déplacements et notes de frais,<br>les cartes affaires (page <u>34</u>)',
      '• L’intranet RH Aptar France SAS, les<br>entretiens professionnels (page <u>35</u>)',
      '• PAE : Programme d’Aide aux<br>Employés (page <u>36</u>)',
      '• EthicsPoint : ligne d’assistance (page <u>37</u>)',
      '• Simplification Administrative / Déclaration<br>Sociale Nominative (page <u>38</u>)',
      '• Liste des documents qui vous ont été remis à la signature de votre contrat (page <u>39</u>)',
   ]

   return (
      <div onClick={handleContainerClick}>
         <PBoldExt fontSize='24px' color={Colors.gris1}>
            LE GUIDE PRATIQUE RH LE NEUBOURG – LOUVECIENNES
         </PBoldExt>
         <PExt justify fontSize='24px' color={Colors.gris2}>
            Il contient toutes les informations nécessaires pour que vous puissiez vous familiariser
            le plus rapidement possible avec le fonctionnement de notre société.
         </PExt>
         <br />

         <div className='flex' style={{ alignItems: 'start' }}>
            <div className='flex column alignStart'>
               <PBoldExt fontSize='24px' color={Colors.corail}>
                  APTARGROUP (pages <u>5</u> et <u>6</u>)
               </PBoldExt>
               <br />
               <PBoldExt fontSize='24px' color={Colors.corail}>
                  VOTRE SERVICE DES RESSOURCES HUMAINES (page <u>7</u>)
               </PBoldExt>
               <br />
               <PBoldExt fontSize='24px' color={Colors.corail}>
                  BIENVENUE AU NEUBOURG (page <u>8</u>)
               </PBoldExt>
               <Li color={colorLi} helveticaLight fontSize='20px'>
                  • Les horaires de travail et le pointage (page <u>10</u>)
               </Li>
               <Li color={colorLi} helveticaLight fontSize='20px'>
                  • Votre sécurité (pages <u>11</u> et <u>12</u>)
               </Li>
               <Li color={colorLi} helveticaLight fontSize='20px'>
                  • Votre santé (page <u>13</u>)
               </Li>
               <Li color={colorLi} helveticaLight fontSize='20px'>
                  • Le Restaurant d’Entreprise (page <u>13</u>)
               </Li>
            </div>
            <div className='flex center column' style={{ width: '60%' }}>
               <img
                  src={`${process.env.PUBLIC_URL}/img/Couverture-Guide pratique RH Le Neubourg - Louveciennes _ Juillet 2023.jpg`}
                  style={{
                     border: `1px ${Colors.black} solid`,
                     marginBottom: '5px',
                     width: '200px',
                  }}
                  alt=''
                  onClick={() => openPdf(1)}
               />
               <img
                  width={40}
                  style={{ position: 'absolute', right: 30, bottom: 80 }}
                  src={`${process.env.PUBLIC_URL}/img/picto_black.png`}
               />
               <PExt center fontSize='16px' color={colorLi}>
                  Cliquez pour
                  <br />
                  accéder au contenu
                  <br />
                  du guide RH
               </PExt>
            </div>
         </div>
         <br />
         <PBoldExt uppercase fontSize='24px' color={Colors.corail}>
            Tout ce que vous voulez savoir sur
         </PBoldExt>
         <div className='w100 flex between' style={{ height: 450 }}>
            <div className='flex column alignStart w100 h100'>
               {Li3.map((text, i) => (
                  <Li key={i} color={colorLi} helveticaLight fontSize='20px'>
                     {HTMLReactParser(text)}
                  </Li>
               ))}
            </div>
            <div className='flex column alignStart w100 h100'>
               {Li4.map((text, i) => (
                  <Li key={i} color={colorLi} helveticaLight fontSize='20px'>
                     {HTMLReactParser(text)}
                  </Li>
               ))}
            </div>
         </div>

         {isPopupOpen && (
            <Popup open={isPopupOpen} modal onClose={closePopup}>
               <PdfReader
                  file={`guide-pratique.pdf`}
                  close={closePopup}
                  qrcode='/img/qrRèglement intérieur.png'
                  initialPage={initialPage}
               />
            </Popup>
         )}
      </div>
   )
}
